// @ts-nocheck
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import AdminAuth from "./components/auth/AdminAuth";
import RequireAuth from "./components/auth/RequireAuth";
import Layout from "./components/layout/Layout";
import useSession from "./hooks/useSession";
import AboutUs from "./pages/AboutUs/AboutUs";
import BusinessSubsContentPage from "./pages/AboutUs/businessSubs/BusinessSubsContentPage";
import BusinessSubsCreate from "./pages/AboutUs/businessSubs/BusinessSubsCreate";
import BoardContentPage from "./pages/AboutUs/board/BoardContentPage";
import BoardListPage from "./pages/AboutUs/board/BoardListPage";
import BoardUniquePage from "./pages/AboutUs/board/BoardUniquePage";
import CareerListPage from "./pages/AboutUs/career/CareerListPage";
import CareerContentPage from "./pages/AboutUs/career/CareerContentPage";
import CareerUniquePage from "./pages/AboutUs/career/CareerUniquePage";
import CertificateContentPage from "./pages/AboutUs/certificates/CertificateContentPage";
import CertificateListPage from "./pages/AboutUs/certificates/CertificateListPage";
import CertificateUniquePage from "./pages/AboutUs/certificates/CertificateUniquePage";
import GalleryContentPage from "./pages/AboutUs/gallery/GalleryContentPage";
import ManagementsContentPage from "./pages/AboutUs/managements/ManagementsContentPage";
import ManagementsListPage from "./pages/AboutUs/managements/ManagementsListPage";
import ManagementsUniquePage from "./pages/AboutUs/managements/ManagementsUniquePage";
import NewsAndEventsListPage from "./pages/AboutUs/newsAndEvents/NewsAndEventsListPage";
import NewsAndEventsUniquePage from "./pages/AboutUs/newsAndEvents/NewsAndEventsUniquePage";
import HomeAbout from "./pages/HomePage/HomeAbout";
import HomeBanner from "./pages/HomePage/HomeBanner";
import HomeCounter from "./pages/HomePage/HomeCounter";
import HomePartners from "./pages/HomePage/HomePartners";
import HiringPartnersCreate from "./pages/HomePage/hiringPartners/HiringPartnersCreate";
import HomeProjects from "./pages/HomePage/HomeProjects";
import HomeSubsidaries from "./pages/HomePage/HomeSubsidaries";
import { RoutePath } from "./utility/Constant";
import WorkforceContentPage from "./pages/services/workforce/WorkforceContentPage";
import WorkforceListPage from "./pages/services/workforce/WorkforceListPage";
import WorkforceUniquePage from "./pages/services/workforce/WorkforceUniquePage";
import TrainingPage from "./pages/services/training/TrainingPage";
import VisaPage from "./pages/services/visa/VisaPage";
import SelectionBannerPage from "./pages/services/selection/SelectionBannerPage";
import SelectionContentPage from "./pages/services/selection/SelectionContentPage";
import SelectionUniquePage from "./pages/services/selection/SelectionUniquePage";
import ProjectsBannerPage from "./pages/projects/ProjectsBannerPage";
import ProjectsContentPage from "./pages/projects/ProjectsContentPage";
import ProjectsUniquePage from "./pages/projects/ProjectsUniquePage";
import JobsBannerPage from "./pages/projects/jobs/JobsBannerPage";
import JobsContentPage from "./pages/projects/jobs/JobsContentPage";
import JobsUniquePage from "./pages/projects/jobs/JobsUniquePage";
import ContactsBannerPage from "./pages/contact/ContactsBannerPage";
import ContactContentPage from "./pages/contact/ContactContentPage";
import ContactList from "./pages/contact/ContactList";
import ContactsUniquePage from "./pages/contact/ContactsUniquePage";
import CertificateCreate from "./pages/AboutUs/certificates/CertificateCreate";
import BoardCreate from "./pages/AboutUs/board/BoardCreate";
import ManagementCreate from "./pages/AboutUs/managements/ManagementCreate";
import NewsAndEventsCreate from "./pages/AboutUs/newsAndEvents/NewsAndEventsCreate";
import WorkforceCreate from "./pages/services/workforce/WorkforceCreate";
import SelectionCreate from "./pages/services/selection/SelectionCreate";
import ProjectsCreate from "./pages/projects/ProjectsCreate";
import JobsContentCreate from "./pages/projects/jobs/JobsContentCreate";
import ContactCreate from "./pages/contact/ContactCreate";
import CareerCreate from "./pages/AboutUs/career/CareerCreate";
import GalleryCreate from "./pages/AboutUs/gallery/GalleryCreate";
import LoginPage from "./pages/login/LoginPage";
import UserAuth from "./components/auth/UserAuth";
import CreateUserPage from "./pages/user/CreateUserPage";
import CreateUserProfilePage from "./pages/user/CreateUserProfilePage";
import UsersList from "./pages/user/UsersList";

function App() {
  const [user] = useSession();
  const {
    homeBanner,
    homeAbout,
    homePartners,
    homePartnersAdd,
    homeProjects,
    homeCounter,
    homeSubsidaries,

    aboutUs,
    aboutUsBusinessSubs,
    aboutUsBusinessSubsAdd,
    aboutUsCertificateContent,
    aboutUsCertificateList,
    aboutUsCertificateListAdd,
    dynamicAboutUsCertificateList,
    aboutUsBoardContent,
    aboutUsBoardList,
    aboutUsBoardListAdd,
    dynamicAboutUsBoardList,
    aboutUsManagementsContent,
    aboutUsManagementsList,
    aboutUsManagementsListAdd,
    dynamicAboutUsManagements,
    aboutUsNews,
    aboutUsNewsAdd,
    dynamicAboutUsNews,
    aboutUsGalleries,
    aboutUsGalleriesAdd,
    aboutUsCareerContent,
    aboutUsCareerList,
    aboutUsCareerListAdd,
    dynamicAboutUsCareerList,
    servicesWorkforceContent,
    servicesWorkforceList,
    servicesWorkforceListAdd,
    dynamicWorkforceList,
    servicesTraining,
    servicesVisa,
    selectionBanner,
    selectionContent,
    selectionContentAdd,
    dynamicSelectionContent,
    projectsBanner,
    projectsContent,
    projectsContentAdd,
    dynamicProjectsContent,
    jobsBanner,
    jobsContent,
    jobsContentAdd,
    dynamicJobsContent,

    contactBanner,
    contactContent,
    contactList,
    contactListAdd,
    dynamicContactList,
    login,
    userList,
  } = RoutePath;

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route
            index
            element={
              <Navigate to={user?.role === "admin" ? homeBanner : login} />
            }
          />
          <Route path={homeBanner} element={<HomeBanner />} />
          <Route path={homeAbout} element={<HomeAbout />} />
          <Route path={homePartners} element={<HomePartners />} />
          <Route path={homePartnersAdd} element={<HiringPartnersCreate />} />
          <Route path={homeProjects} element={<HomeProjects />} />
          <Route path={homeCounter} element={<HomeCounter />} />
          {/* <Route path={homeSubsidaries} element={<HomeSubsidaries />} /> */}
          <Route
            path={aboutUs}
            element={
              // <AdminAuth>
              <AboutUs />
              // </AdminAuth>
            }
          />
          <Route
            path={aboutUsCertificateContent}
            element={<CertificateContentPage />}
          />
          {/* new added */}
          <Route
            path={aboutUsBusinessSubs}
            element={<BusinessSubsContentPage />}
          />
          <Route
            path={aboutUsBusinessSubsAdd}
            element={<BusinessSubsCreate />}
          />

          <Route
            path={aboutUsCertificateList}
            element={<CertificateListPage />}
          />
          <Route
            path={aboutUsCertificateListAdd}
            element={<CertificateCreate />}
          />
          <Route
            path={dynamicAboutUsCertificateList}
            element={<CertificateUniquePage />}
          />
          <Route path={aboutUsBoardContent} element={<BoardContentPage />} />
          <Route path={aboutUsBoardList} element={<BoardListPage />} />
          <Route path={aboutUsBoardListAdd} element={<BoardCreate />} />
          <Route path={dynamicAboutUsBoardList} element={<BoardUniquePage />} />
          <Route
            path={aboutUsManagementsContent}
            element={<ManagementsContentPage />}
          />
          <Route
            path={aboutUsManagementsList}
            element={<ManagementsListPage />}
          />
          <Route
            path={aboutUsManagementsListAdd}
            element={<ManagementCreate />}
          />
          <Route
            path={dynamicAboutUsManagements}
            element={<ManagementsUniquePage />}
          />
          <Route path={aboutUsNews} element={<NewsAndEventsListPage />} />
          <Route path={aboutUsNewsAdd} element={<NewsAndEventsCreate />} />
          <Route
            path={dynamicAboutUsNews}
            element={<NewsAndEventsUniquePage />}
          />
          <Route path={aboutUsGalleries} element={<GalleryContentPage />} />
          <Route path={aboutUsGalleriesAdd} element={<GalleryCreate />} />
          <Route path={aboutUsCareerContent} element={<CareerContentPage />} />
          <Route path={aboutUsCareerList} element={<CareerListPage />} />
          <Route path={aboutUsCareerListAdd} element={<CareerCreate />} />
          <Route
            path={dynamicAboutUsCareerList}
            element={<CareerUniquePage />}
          />

          <Route
            path={servicesWorkforceContent}
            element={<WorkforceContentPage />}
          />
          <Route path={servicesWorkforceList} element={<WorkforceListPage />} />
          <Route
            path={servicesWorkforceListAdd}
            element={<WorkforceCreate />}
          />
          <Route
            path={dynamicWorkforceList}
            element={<WorkforceUniquePage />}
          />

          <Route path={servicesTraining} element={<TrainingPage />} />
          <Route path={servicesVisa} element={<VisaPage />} />

          <Route path={selectionBanner} element={<SelectionBannerPage />} />
          <Route path={selectionContent} element={<SelectionContentPage />} />
          <Route path={selectionContentAdd} element={<SelectionCreate />} />
          <Route
            path={dynamicSelectionContent}
            element={<SelectionUniquePage />}
          />

          <Route path={projectsBanner} element={<ProjectsBannerPage />} />
          <Route path={projectsContent} element={<ProjectsContentPage />} />
          <Route path={projectsContentAdd} element={<ProjectsCreate />} />
          <Route
            path={dynamicProjectsContent}
            element={<ProjectsUniquePage />}
          />

          <Route path={jobsBanner} element={<JobsBannerPage />} />
          <Route path={jobsContent} element={<JobsContentPage />} />
          <Route path={jobsContentAdd} element={<JobsContentCreate />} />
          <Route path={dynamicJobsContent} element={<JobsUniquePage />} />

          <Route path={contactBanner} element={<ContactsBannerPage />} />
          <Route path={contactContent} element={<ContactContentPage />} />
          <Route path={contactList} element={<ContactList />} />
          <Route path={contactListAdd} element={<ContactCreate />} />
          <Route path={dynamicContactList} element={<ContactsUniquePage />} />

          {/* <Route
            path={userCreate}
            element={
              <AdminAuth>
                <CreateUserPage />
              </AdminAuth>
            }
          />
          <Route
            path={userProfile}
            element={
              <AdminAuth>
                <CreateUserProfilePage />
              </AdminAuth>
            }
          /> */}
        </Route>
        <Route
          path={userList}
          element={
            <AdminAuth>
              <UsersList />
            </AdminAuth>
          }
        />

        <Route
          path={login}
          element={
            <UserAuth>
              <LoginPage />
            </UserAuth>
          }
        />
      </Routes>
    </>
  );
}

export default App;
